import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const rotatingBadgeAnimation = () => {
	const badges = document.querySelectorAll('.js-rotating-badge');

	if (badges) {
		gsap.registerPlugin(ScrollTrigger);

		badges.forEach(badge => {
			const parentSection = badge.closest('section');

			if (parentSection) {
				let mm = gsap.matchMedia();
				mm.add('(prefers-reduced-motion: no-preference) and (min-width: 992px)', context => {
					let tl = gsap.timeline({
						scrollTrigger: {
							trigger: parentSection,
							scrub: 0.5,
							start: 'top bottom',
							end: 'bottom top',
						},
					});
					tl.to(badge, {
						rotation: 360 * 1.125,
					});
				});
			}
		});
	}
};

rotatingBadgeAnimation();
